import { render, staticRenderFns } from "./StatusTag.vue?vue&type=template&id=e9930f64&scoped=true&"
import script from "./StatusTag.vue?vue&type=script&lang=js&"
export * from "./StatusTag.vue?vue&type=script&lang=js&"
import style0 from "./StatusTag.vue?vue&type=style&index=0&id=e9930f64&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9930f64",
  null
  
)

export default component.exports